export default __webpack_public_path__ + "media/video_thumbnail1.71cb1c03.png";